import { render, staticRenderFns } from "./ConfirmSuccessModal.vue?vue&type=template&id=2fd490b0"
import script from "./ConfirmSuccessModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSuccessModal.vue?vue&type=style&index=0&id=2fd490b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports